import { useEffect, useRef } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useCryptoTransfer } from "hooks";

interface IProps {
  initialRecipientAddress: string;
}
const CryptoTransferForm = ({ initialRecipientAddress }: IProps) => {
  const { recipientAddress, isLoading, handleTransfer } = useCryptoTransfer(initialRecipientAddress);

  const calledOnce = useRef(false);
  useEffect(() => {
    if (!calledOnce.current) {
      recipientAddress && handleTransfer();
      calledOnce.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipientAddress]);

  return (
    <Box mt="42px">
      {isLoading && (
        <Text fontWeight="500" color="#6FBE45" fontSize="18px">
          Please, confirm or reject transaction in Metamask
        </Text>
      )}
    </Box>
  );
};

export default CryptoTransferForm;
